import React from "react";
import { firestore } from '../firebase.js';
import { Link } from 'react-router-dom';
import '../Styles/Sass/UserListingCard.scss';

function UserListingCard(props) {
  const [takenBy, setTakenBy] = React.useState('open');

  React.useEffect(() => {
    getUserName();
  }, [props.job, props.takenBy]);

  const getUserName = () => {
    if (props.takenBy !== 'open') {
      firestore.collection('users').doc(props.takenBy).get()
        .then(res => {
          let userName = res.data().name;
          setTakenBy(userName);
        })
        .catch(err => {
          console.log(err);
        });
      }
  };

  return (
    <li
      className={
        props.takenBy !== 'open' ?
        'jobCard' :
        'jobCard jobCard--open'
      }
      onClick={
        props.takenBy === 'open' ?
        () => {props.openModal(props.job)} :
        () => console.log('taken')
      }
    >
      <h3 className='jobCard__headline'>{props.job.headline}</h3>
      <p className='jobCard__description'>{props.job.description}</p>
      <h4 className='jobCard__subtitle'>Status</h4>
      <p className='jobCard__status'>
        {
          takenBy === 'open' ?
            'Open' :
            `Cleaner Chosen: ${takenBy}`
        }
      </p>
      <div className='jobCard__subBox'>
        <p className='jobCard__rate'>${props.job.rate} per hour</p>
        <p className='jobCard__location'>
          {props.job.city} | {props.job.postal} | {props.job.province}
        </p>
      </div>
    </li>
  );
}

export default UserListingCard;